import React from 'react';
import { useLocation } from '@remix-run/react';
import classNames from 'classnames';

import Link from '~/components/link';
import { type Group } from '~/interfaces/HeaderFooterNavV2';
import { getPathWithSingleRepub } from '~/utils/getPathWithSingleRepub';

import styles from './split-nav-links.module.css';

interface IProps {
  callback?: (label: string) => void;
  label: string;
  links: Group[];
}

interface ISplitNavLinksProps extends IProps {
  selectedTab: string;
}

const SplitNavLinks = ({
  callback,
  label,
  links,
  selectedTab
}: ISplitNavLinksProps): JSX.Element => {
  const url = useLocation();
  return (
    <>
			{links.map(({ items, name }) => {
        const isSelected = name === selectedTab;

        return items?.map(({ link, name }) => {
          const cleanLink = getPathWithSingleRepub(url.pathname, link);

          return (
            <Link
              className={classNames(
                styles.splitMenuLinkItem,
                isSelected ? '' : styles.hidden
              )}
              key={name}
              preCallback={() =>
              callback?.(`${label} - ${selectedTab} - ${name}`)
              }
              to={cleanLink}>

							{name}
						</Link>);

        });
      })}
		</>);

};

const SplitNav = ({ callback, label, links }: IProps): JSX.Element => {
  const [selectedTab, setSelectedTab] = React.useState(
    () => links?.[0]?.name || ''
  );

  return (
    <div className={styles.splitMenu} data-testid="split-nav-component">
			<div className={styles.splitMenuTab}>
				{links.map((item) => {
          return (
            <div
              className={classNames(
                styles.splitMenuTabItem,
                selectedTab === item.name ?
                styles.splitMenuTabItemSelected :
                ''
              )}
              key={item.name}
              onClick={() => setSelectedTab(item.name)}>

							<div className={styles.splitMenuTabText}>{item.name}</div>
						</div>);

        })}
			</div>
			<div className={styles.splitMenuLinks}>
				<SplitNavLinks
          callback={callback}
          label={label}
          links={links}
          selectedTab={selectedTab} />

			</div>
		</div>);

};

export default SplitNav;